import { api } from "@/api";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { sleep } from "@/shared/utils";
import { useMutation } from "@tanstack/react-query";
import { ReactNode } from "react";

export async function editUsuarioPassword(id: string, newPassword: string): Promise<void> {
    await sleep(1000);
    const response = await api.put("usuarios/password/" + id, { newPassword });
    return response.data;
}

export function useEditUsuarioPasswordMutation(id: string, mutationOptions: MutationConfig<void, string> = {}) {
    return useMutation({
        ...mutationOptions,
        mutationFn: async (newPassword: string) => await editUsuarioPassword(id, newPassword),
        onSuccess: (...args) => {
            mutationOptions.onSuccess && mutationOptions.onSuccess(...args);
        },
    })
}

export interface EditUsuarioPasswordMutationProps{
    id: string, 
    mutationConfig?: MutationConfig<void, string>,
    children?:(mutationResult:MutationResult<void, string>)=>ReactNode
}

export function EditUsuarioPasswordMutation({
    id,
    children,
    mutationConfig
}:EditUsuarioPasswordMutationProps){
    const mutationResult = useEditUsuarioPasswordMutation(id, mutationConfig);
    return children&&children(mutationResult)
}